import { defineStore } from 'pinia'
import { markRaw } from 'vue'

import DefaultModal from '@/components/ui/DefaultModal.vue'

import type {
  ModalOptions,
  ModalState,
  ModalResult
} from '@/types/stores/modalStore.type.ts';

export const useModalStore = defineStore('modal', {
  state: (): ModalState => ({
    isOpen: false,
    component: null,
    props: {},
    _resolver: null
  }),
  actions: {
    openModal(options: ModalOptions): Promise<ModalResult> {
      if (options.component) {
        this.component = markRaw(options.component)
      } else {
        this.component = markRaw(DefaultModal)
      }

      this.props = options.props || {
        title: options.title,
        message: options.message,
        validateButton: options.validateButton,
        cancelButton: options.cancelButton
      }

      this.isOpen = true

      return new Promise((resolve) => {
        this._resolver = resolve
      })
    },
    closeModal(result: ModalResult = null) {
      this.isOpen = false
      this.component = null
      this.props = {}
      if (this._resolver) {
        this._resolver(result)
        this._resolver = null
      }
    }
  }
})
